export const API_URL = "https://erdosdigital.com/api/v1/";